/* eslint-disable no-unused-vars */
import httpService from '@/services/httpService'

// export const types = {
//   ADD_AGENCY_DATA: 'agency/ADD_AGENCY_DATA'
// }
// const state = {
//   agencies: []
// }
//
// const mutations = {
//   [types.ADD_AGENCY_DATA]: function (state, agencies) {
//     state.agencies = agencies || []
//   }
// }

const actions = {
  resetPassword: async function (store, params) {
    const response = await httpService.post('/user/forgot-password', params)
    if (!response || !response.data) {
      return {}
    }
    return response.data
  },
  loginUser: async function (store, params) {
    const response = await httpService.post('/user/sign-in', params)
    if (!response || !response.data) {
      return {}
    }
    return response.data
  },
  registerUser: async function (store, { method, ...params }) {
    const request = httpService[method]
    const response = await request('/user/register', params)
    if (!response || !response.data) {
      return {}
    }
    return response.data
  }
}

export default {
  namespaced: true,
  // state,
  actions,
  // mutations
}
